import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../config";

export const useSignup = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@std\.must\.ac\.ug$/;
    if (!regex.test(email)) {
      return "Please enter a valid student email address";
    }
    return null;
  };

  const validatePassword = (password, confirmPassword) => {
    if (password !== confirmPassword) {
      return "Passwords do not match";
    }
    return null;
  };

  const validatePhoneNumber = (phoneNumber) => {
    const regex = /^\+\d{7,15}$/;
    if (!regex.test(phoneNumber)) {
      return "Please enter a valid phone number starting with 07 and containing exactly ten digits";
    }
    return null;
  };

  const validateRegNumber = (regNumber) => {
    const regex = /^(20[0-9]{2})\/[A-Z]{3}\/[0-9]{3}([\/][A-Z]{2})?$/;
    if (!regex.test(regNumber)) {
      return "Please enter a valid registration number in the format: 2020/BSE/043 or 2020/BSE/043/PS";
    }
    return null;
  };

  const validateYearOfStudy = (yearOfStudy) => {
    const year = parseInt(yearOfStudy);
    if (year < 1 || year > 5 || isNaN(year)) {
      return "Year of study must be between 1 and 5";
    }
    return null;
  };

  const validateAcademicYear = (academicYear) => {
    if (!academicYear) {
      return "Academic Year Missing";
    }
    return null;
  };

  const validateInputs = (inputs) => {
    const {
      email,
      password,
      confirmPassword,
      phoneNumber,
      regNumber,
      yearOfStudy,
      academicyear,
    } = inputs;

    const validators = [
      validateEmail(email),
      validatePassword(password, confirmPassword),
      validatePhoneNumber(phoneNumber),
      validateRegNumber(regNumber),
      validateYearOfStudy(yearOfStudy),
      validateAcademicYear(academicyear),
    ];

    const errors = validators.filter((error) => error !== null);
    if (errors.length > 0) {
      setError(errors[0]);
      return false;
    }

    setError(null);
    return true;
  };

  const signup = async (
    first_name,
    last_name,
    email,
    programme,
    academicyear,
    password,
    confirmPassword,
    regNumber,
    phoneNumber,
    yearOfStudy
  ) => {
    const inputs = {
      email,
      password,
      confirmPassword,
      phoneNumber,
      regNumber,
      yearOfStudy,
      academicyear,
    };

    if (!validateInputs(inputs)) {
      return; // Exit early if validation fails
    }

    setIsLoading(true);

    try {
      const response = await fetch(`${API_URL}/students/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          first_name,
          last_name,
          email,
          programme,
          academicyear,
          regNumber,
          phoneNumber,
          yearOfStudy,
          password,
        }),
      });

      if (!response.ok) {
        const json = await response.json();
        throw new Error(json.error);
      }

      const json = await response.json();
      navigate("/confirmsignup", { state: { email: json.studentemail } });
    } catch (error) {
      setError(error.message || "An error occurred during signup");
    } finally {
      setIsLoading(false);
    }
  };

  return { signup, isLoading, error };
};
